"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class Input extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.classNamesByState = {
            disabled: 'disabled',
            error: 'error',
            focus: 'focus'
        };
        this.classNamesBySize = {
            sm: 'vf-input--sm',
            lg: 'vf-input--lg'
        };
        this.getClassNames = () => {
            const { state, inputSize, error, disabled, className } = this.props;
            return [
                'vf-input',
                className,
                this.classNamesByState[state],
                this.classNamesBySize[inputSize],
                (disabled ? 'disabled' : null),
                (error ? 'error' : null)
            ].join(' ');
        };
    }
    render() {
        const _a = this.props, { state, inputSize, error, className } = _a, other = __rest(_a, ["state", "inputSize", "error", "className"]);
        return (React.createElement("input", Object.assign({}, other, { className: this.getClassNames(), disabled: state === 'disabled' })));
    }
}
Input.defaultProps = {
    state: 'normal',
    inputSize: 'md',
    icon: null
};
exports.default = Input;
